module.exports = __webpack_public_path__ + "static/media/intro.e340600f.mp3";